import { useState, useEffect } from 'react';
import { CLOCK_INTERVAL_MS } from '../constants';

export function usePunchcardClock(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), CLOCK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);
  return now;
}
